<template>
  <div id="KeywordAdvertDetail" style="width: 100%; margin: 0 auto; background: white">
    <div ref="header" class="header-box">
      <div class="header-line">
        <span class="header-label">产品类型</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productType" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
        </el-select>
        <span class="header-label">产品颜色</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productColor">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
        </el-select>
        <span class="header-label">机型</span>
        <el-select placeholder="产品机型" size="small" v-model="productModel">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
        </el-select>
        <span class="header-label">SKU</span>
        <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sku"> </el-input>
        <span class="header-label">Asin</span>
        <el-input placeholder="请输入Asin" size="small" clearable v-model="params.asin"> </el-input>
        <span class="header-label">日期</span>
        <el-date-picker v-model="params.date" type="date" placeholder="选择日期" style="width: 150px"> </el-date-picker>
        <el-button type="primary" size="small" @click="getAdvertData">查询</el-button>
        <el-button type="primary" size="small" @click="addKeywords">新增</el-button>
        <el-button type="primary" size="small" @click="startKWAdvertTask">生成数据</el-button>
        <el-button type="primary" size="small" @click="priceBtn">批量改价</el-button>
      </div>
    </div>
    <el-table ref="table" :data="tableData" stripe size="mini" :height="screenHeight" row-key="_id" lazy :load="load" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" :highlight-current-row="true" border @selection-change="handleSelectionChange" show-summary>
      <el-table-column type="selection" width="55" algin="center"> </el-table-column>
      <el-table-column width="50px"> </el-table-column>
      <el-table-column label="操作" width="50px">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="keywordAnalysis(scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="60px" sortable>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.State" v-if="scope.row.productAd != 1" @change="onStateChange(scope.row)" size="mini" active-value="已启用" inactive-value="已暂停" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="recommandState" label="推荐状态" width="40px">
        <template v-slot="scope">
          <div :class="getRecommandStateStyleClass(scope.row)">{{ scope.row.recommandState }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="weight" label="权重" width="60px" align="right"> </el-table-column>
      <el-table-column prop="sku" label="SKU" width="200px"> </el-table-column>
      <el-table-column prop="asin" label="Asin" width="100px"> </el-table-column>
      <el-table-column prop="productName" label="产品名称" width="80px" sortable> </el-table-column>
      <el-table-column prop="productColorName" label="颜色" width="80px" sortable> </el-table-column>
      <el-table-column prop="model" label="机型" width="80px" sortable> </el-table-column>
      <el-table-column prop="Keyword Text" label="关键词" width="200px" sortable> </el-table-column>
      <el-table-column prop="Bid" label="单价" width="80px" align="right" sortable>
        <template slot-scope="scope">
          <el-input v-model="scope.row.Bid" @change="onBidChange(scope.row)" size="mini" v-if="scope.row.productAd != 1"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="recommandBid" label="推荐单价" width="40px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getRecommandBidStyleClass(scope.row)" @click="onRecommandBidClick(scope.row)" style="cursor: pointer">{{ scope.row.recommandBid }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="CPC" label="CPC" width="60px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.CPC.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Impressions" label="展现量" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Clicks" label="点击量" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Click-through Rate" label="点击率" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (scope.row["Click-through Rate"] * 100).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="Spend" label="花费" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.Spend.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Sales" label="销售额" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.Sales.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Orders" label="订单数" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Units" label="销售数量" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Conversion Rate" label="点击转化率" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div>{{ Math.round(scope.row["Conversion Rate"] * 10000) / 100 + "%" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="ROAS" label="ROAS" width="60px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.ROAS.toFixed(2) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>

    <el-dialog title="新增关键词" :visible.sync="dialogFormVisible" width="25%">
      <div class="dialog-content">
        <el-input type="textarea" :rows="10" placeholder="请输入关键词" v-model="keywordsText"> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitKeywords">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量改价" :visible.sync="dialogVisible" width="25%">
      <div class="dialog-content">
        <el-form ref="form" label-width="80px">
          <el-form-item label="操作类型">
            <el-radio-group v-model="changeType">
              <el-radio :label="1" :value="1">增加</el-radio>
              <el-radio :label="2" :value="2">减少</el-radio>
              <el-radio :label="3" :value="3">覆盖</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="快捷选项">
            <el-radio-group v-model="quickPrice" @input="onQuichPriceChange">
              <el-radio :label="0.05" :value="0.05">0.05</el-radio>
              <el-radio :label="0.1" :value="0.1">0.1</el-radio>
              <el-radio :label="0.2" :value="0.2">0.2</el-radio>
              <el-radio :label="0.3" :value="0.3">0.3</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="金额">
            <el-input type="number" placeholder="请输入" v-model="keywordPrice"> </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPrice">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { products, activeProducts, colors, models } from "../../utils/constant.js";
export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 54 - 68,
      total: 0,
      pageCount: 1,
      dialogFormVisible: false,
      dialogVisible: false,
      totalPage: 1,
      advertData: [],
      keywordsText: "",
      multipleSelection: [],
      changeType: 1,
      keywordPrice: 0.1,
      quickPrice: 0.1,
      asin: this.$route.query.asin,
      entity: this.$route.query.entity,
      productTargetingId: this.$route.query.productTargetingId,
      sku: "",
      productType: "",
      productColor: "",
      productModel: "",
      productList: activeProducts,
      colorList: colors,
      modelList: models,
      date: "",
      params: { pageSize: 100, sku: "", date: "", asin: this.$route.query.asin, Entity: "关键词", beginIndex: 0, productType: "", productColor: "", productModel: "", createType: 1 },
    };
  },
  watch: {
    // 'params.productType': {
    //   handler: function (newValue, oldValue) {
    //     let product = products.find(product => product.productType == newValue);
    //     let color = colors.find(color => color.key = product.defaultColor);
    //     this.params.productColor = color.key;
    //   },
    //   deep: true
    // },
    productModel: {
      handler: function (newValue, oldValue) {
        let blankReg = new RegExp(" ", "igm");
        let productModel = newValue.replace(blankReg, "");
        this.params.productModel = productModel;
      },
    },
  },
  mounted() {
    // console.log(document.body.clientHeight)
    // console.log(this.screenHeight);
    // this.screenHeight = document.body.clientHeight - 55 - this.$refs.header.clientHeight - this.$refs.pageNav.$el.clientHeight
    // console.log(this.screenHeight, document.body.clientHeight, 55, this.$refs.header.clientHeight, this.$refs.pageNav.$el.clientHeight);
    this.getAdvertData();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 54 - 68;
    },
    addKeywords() {
      this.dialogFormVisible = true;
    },
    submitKeywords() {
      let keywordSet = new Set(this.keywordsText.trim().split("\n"));
      let params = {
        asin: this.$route.query.asin,
        keywords: JSON.stringify(Array.from(keywordSet)),
      };
      requestModules.addManualKeywordAdvert(params).then(res => {
        console.log(res);
        this.getAdvertData();
      });
      this.dialogFormVisible = false;
    },
    startKWAdvertTask() {
      requestModules.startKWAdvertTask().then(res => {
        this.$confirm("生成完成", "提示", {
          confirmButtonText: "确定",
          type: "info",
        }).then(() => {});
      });
    },
    onQuichPriceChange(val) {
      this.keywordPrice = val;
    },
    priceBtn() {
      if (this.multipleSelection.length <= 0) {
        this.$message({
          message: "请至少选择一条记录",
          type: "warning",
        });
      }
      this.dialogVisible = true;
    },
    submitPrice() {
      this.$confirm("是否确认批量修改单次点击价格?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.multipleSelection.forEach(advert => {
            let bid = Number(advert.Bid);
            let keywordPrice = Number(this.keywordPrice);
            this.changeType == 1 && (bid += keywordPrice);
            this.changeType == 2 && (bid -= keywordPrice);
            this.changeType == 3 && (bid = keywordPrice);
            let params = {
              id: advert._id,
              Bid: bid.toFixed(2),
            };
            requestModules.updateProductAdvert(params).then(res => {
              console.log(res);
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });

      this.dialogVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onStateChange(row) {
      // debugger
      // row.State = row.State == "enabled" ? "paused" : "enabled";
      let params = {
        id: row._id,
        State: row.State,
      };
      requestModules.updateProductAdvert(params).then(res => {
        console.log(res);
      });
    },
    onDailyBudgetChange(row) {},
    onBidChange(row) {
      this.$confirm("是否确认修改单次点击价格?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row._id,
            Bid: row.Bid,
          };
          requestModules.updateProductAdvert(params).then(res => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    onRecommandBidClick(row) {
      this.$confirm("是否确认修改单次点击价格?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row._id,
            Bid: row.recommandBid,
          };
          requestModules.updateProductAdvert(params).then(res => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            row.Bid = row.recommandBid;
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    getRecommandStateStyleClass(row) {
      let styleClass = "";
      row.recommandState == "暂停" && row.State == "已启用" && (styleClass = "redBg");
      // row.recommandState == "2" && (styleClass = "redBg");
      return styleClass;
    },
    getRecommandBidStyleClass(row) {
      let styleClass = "";
      row.recommandBid > row.Bid && (styleClass = "greenBg");
      row.recommandBid < row.Bid && (styleClass = "redBg");
      // row.recommandState == "2" && (styleClass = "redBg");
      return styleClass;
    },
    getAdvertData() {
      requestModules.fetchAdverts(this.params).then(res => {
        this.advertData = res.ldata;
        this.total = res.total;
      });
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getAdvertData();
    },
    load(tree, treeNode, resolve) {
      let params = { pageSize: 10000, campaignName: tree["Campaign Name (Informational only)"], adGroupName: tree["Ad Group Name (Informational only)"], keyword: tree["Keyword Text"] };
      requestModules.fetchDetailKeywordAds(params).then(res => {
        resolve(res.ldata);
      });
    },
    keywordAnalysis(row) {
      // let adGroupName = row["Ad Group Name (Informational only)"];

      window.open("/client/keywordAnalysis?keyword=" + row["Keyword Text"] + "&asin=" + row.asin + "&productType=" + row.productType);
    },
  },
  computed: {
    tableData() {
      let list = [...this.advertData];
      // let blankReg = new RegExp(" ", 'igm')
      // let productModel = this.productModel.replace(blankReg, "");
      // this.productType != "" && (list = list.filter(advert => advert.productType == this.productType));
      // this.productColor != "" && (list = list.filter(advert => advert.color == this.productColor));
      // productModel != "" && (list = list.filter(advert => advert.model == productModel));

      // list.sort((a, b) => b.Spend - a.Spend);

      list.forEach(advert => {
        advert.hasChildren = true;
        advert.children = [];
      });
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
      return list;
    },
  },
};
</script>

<style lang="scss">
#KeywordAdvertDetail {
  .header-box {
    text-align: left;
    line-height: 30px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

    .el-input,
    .el-select {
      width: 120px;
      margin-right: 15px;
      margin-left: 5px;
      padding: 0px 5px;
    }

    .el-button {
      width: 80px;
    }

    .header-line {
      margin-bottom: 20px;
    }

    .header-line:last-of-type {
      margin-bottom: 0px;
    }

    .small-margin-right {
      margin-right: 5px;
    }

    .header-label {
      font-size: 16px;
    }
  }
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell {
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }
}
</style>
